@if (showMobileHeader()) {
  <app-lc-header-mobile
    [isUserLoggedIn]="isUserLoggedIn()"
    [notifications]="notifications"
    [newMessages]="newMessages"
    (markNotificationAsReadEvent)="markNotificationAsRead($event)" />
} @else {
  <app-record-header-wrapper
    [notifications]="notifications"
    [newMessages]="newMessages"
    [userName]="userName"
    [userSurname]="userSurname"
    (markNotificationAsReadEvent)="markNotificationAsRead($event)" />
}
